// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 328 ? "admin" : chunkId) + "." + {"328":"6eb36ae9","685":"dcba32ee"}[chunkId] + ".chunk.js";
};